<template>
    <VContainer>
        <VLayout wrap>
            <VFlex xs12>
                <BaseCard v-if="event">
                    <VCardTitle class="font-weight-light headline">
                       {{event.event.name}}
                    </VCardTitle>
                    <VCardText>
                        <VLayout wrap>
                            <VFlex xs12 sm5>
                                <VImg :src="event.event.imgurl" />
                            </VFlex>
                            <VFlex xs12 sm7 class="pa-4 text-center text-justify subtitle-1">
                                {{event.event.description}}
                                <div>
                                    {{event.event.location}}
                                </div>
                                <VLayout wrap v-if="event.event.eventtype==='tourney'" v-for="s in event.skus" class="font-weight-light title">
                                    <VFlex xs6>Division: </VFlex><VFlex xs6 class="font-weight-medium">{{s.attributes.name}}</VFlex>
                                    <VFlex xs6>Cost: </VFlex><VFlex xs6 class="font-weight-medium">${{s.price/100}} Team</VFlex><br/>
                                    <VFlex xs6>Date:</VFlex><VFlex xs6 class="font-weight-medium">{{s.metadata.date}}</VFlex>
                                    <VFlex xs6>Start:</VFlex><VFlex xs6 class="font-weight-medium">{{s.metadata.time}}</VFlex>
                                </VLayout>
                                <VLayout wrap>
                                    <VFlex xs12>
                                        Log in to register....
                                        (we're tracking you now.. )
                                    </VFlex>
                                </VLayout>
                            </VFlex>
                        </VLayout>
                    </VCardText>
                </BaseCard>
                <EventById :eventid="$store.state.eventId" v-else  />
            </VFlex>
        </VLayout>
    </VContainer>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex';
  import BaseBtn from "../BaseBtn";
  import EventById from "../event/EventById";
  export default {
    props:['eventid'],
    components: {EventById, BaseBtn},
    name: "HomePage",
    data() {
      return {

      }
    },
    computed:{
      ...mapState(['event']),
      loggedIn(){
        return this.$store.state.loggedin
      },

    },
    mounted() {
      this.getEvent()
    },
    methods: {
      ...mapActions(['openGet']),
      async getEvent() {
        let em = this;
        let evt = await this.openGet({path: 'api/event/json/'+this.eventid});
        if(!evt.error){
          this.$store.commit('setEvent', evt)
        }
      },
    }
  }
</script>

<style scoped>

</style>